const e = (s) => s.userData.isRgMesh;
export {
  e as isRgMesh
};
//# sourceMappingURL=index2.js.map
